import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware} from 'redux';
import promiseMiddleware from 'redux-promise';
//use bootstrap library
import '../node_modules/bootstrap/dist/css/bootstrap.css';
//get compiled style file from SASS, this file's change will be automatically updated on browser during development
import './static/css/style.css';

import reducers from './reducers';

import App from './app';
//apply redux
const createStoreMiddleWare = applyMiddleware(promiseMiddleware)(createStore);

ReactDOM.render(
    //assign all reducers to 'createStoreMiddleWare'
    <Provider store={createStoreMiddleWare(reducers)}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js